import { render } from "./assessor.vue?vue&type=template&id=0fc5d972"
import script from "./assessor.vue?vue&type=script&lang=js"
export * from "./assessor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__